import React from "react";
import Grid from "@mui/material/Grid";
import {
  HandleError,
  RadioGroup,
  CheckboxGroup,
  NumberField,
  Select,
} from "../form";
import FormRow from "../FormRow";
import {
  LEASE_RENEWAL,
  SUBLETTING_AVAILABLE,
  PROOF_RENTAL_INSURANCE,
  TENANT_SCREENING,
  CREDIT_CHECK,
} from "../../constants";
import Addendums from "../Addendums";

function FormLease({ suffix }) {
  let defaultSuffix = "";
  if (suffix) {
    defaultSuffix = `${suffix}.`;
  }

  const getHourOptions = () => {
    const result = [];
    let i = 0;
    while (i < 24) {
      const hours = `0${i}`.slice(-2);
      result.push({ value: `${hours}:00:00.000`, label: `${hours}:00` });
      result.push({ value: `${hours}:15:00.000`, label: `${hours}:15` });
      result.push({ value: `${hours}:30:00.000`, label: `${hours}:30` });
      result.push({ value: `${hours}:45:00.000`, label: `${hours}:45` });
      i++;
    }
    return result;
  };

  return (
    <>
      <FormRow label="Lease">
        <CheckboxGroup
          list={LEASE_RENEWAL}
          name={`${defaultSuffix}leaseRenewal`}
        />
        <HandleError name={`${defaultSuffix}leaseRenewal`} />
      </FormRow>

      <FormRow label="Number of Days Guest Allowed">
        <NumberField name={`${defaultSuffix}daysGuestsAllowed`} />
      </FormRow>

      <FormRow label="Subletting Available">
        <RadioGroup
          list={SUBLETTING_AVAILABLE}
          name={`${defaultSuffix}sublettingAvailable`}
        />
        <HandleError name={`${defaultSuffix}sublettingAvailable`} />
      </FormRow>

      <FormRow label="Proof of Rental Insurance Required">
        <RadioGroup
          list={PROOF_RENTAL_INSURANCE}
          name={`${defaultSuffix}proofOfRentalInsurance`}
        />
        <HandleError name={`${defaultSuffix}proofOfRentalInsurance`} />
      </FormRow>

      <FormRow label="Tenant Screening">
        <RadioGroup
          list={TENANT_SCREENING}
          name={`${defaultSuffix}tenantScreening`}
        />
        <HandleError name={`${defaultSuffix}tenantScreening`} />
      </FormRow>

      <FormRow label="Credit Check">
        <RadioGroup list={CREDIT_CHECK} name={`${defaultSuffix}creditCheck`} />
        <HandleError name={`${defaultSuffix}creditCheck`} />
      </FormRow>

      <FormRow label="Quiet Hours">
        <Grid
          container
          spacing={1}
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid item xs={12} sm={2}>
            <Select
              name={`${defaultSuffix}quietHours.startLocalTime`}
              options={getHourOptions()}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={1}
            sx={{ textAlign: { sm: "center", xs: "left" } }}
          >
            to
          </Grid>
          <Grid item xs={12} sm={2}>
            <Select
              name={`${defaultSuffix}quietHours.endLocalTime`}
              options={getHourOptions()}
            />
          </Grid>
        </Grid>
      </FormRow>

      <FormRow label="Addendums" hideDivider>
        <Addendums name={`${defaultSuffix}addendums`} />
      </FormRow>
    </>
  );
}

export default FormLease;
